module.exports = __webpack_public_path__ + "static/beerHopper1-50a25f00c43bf9766c456a97ead82329.png";